import { InvestmentPlanTypeIconNamePipe } from './investment-plan-type-icon-name.pipe';
import { AmountPipe } from './amount.pipe';

export const pipes = [AmountPipe, InvestmentPlanTypeIconNamePipe];

export * from './amount.pipe';
export * from './investment-plan-type-icon-name.pipe';
